export const CORE_NEUTRAL_COLOR_TOKEN_NAMES = {
    CORE_COLOR_GREY_01: 'CORE_COLOR_GREY_01',
    CORE_COLOR_GREY_02: 'CORE_COLOR_GREY_02',
    CORE_COLOR_GREY_03: 'CORE_COLOR_GREY_03',
    CORE_COLOR_GREY_04: 'CORE_COLOR_GREY_04',
    CORE_COLOR_GREY_05: 'CORE_COLOR_GREY_05',
    CORE_COLOR_GREY_06: 'CORE_COLOR_GREY_06',
    CORE_COLOR_GREY_07: 'CORE_COLOR_GREY_07',
    CORE_COLOR_GREY_08: 'CORE_COLOR_GREY_08',
    CORE_COLOR_GREY_09: 'CORE_COLOR_GREY_09',
    CORE_COLOR_GREY_10: 'CORE_COLOR_GREY_10',
    CORE_COLOR_BLACK: 'CORE_COLOR_BLACK',
    CORE_COLOR_WHITE: 'CORE_COLOR_WHITE',
};

export const CORE_COLOR_TOKEN_NAMES = {
    CORE_COLOR_AFFIRMATIVE: 'CORE_COLOR_AFFIRMATIVE',
    CORE_COLOR_BRAND: 'CORE_COLOR_BRAND',
    CORE_COLOR_CANVAS: 'CORE_COLOR_CANVAS',
    CORE_COLOR_CANVAS_ALT: 'CORE_COLOR_CANVAS_ALT',
    CORE_COLOR_CANVAS_BRAND: 'CORE_COLOR_CANVAS_BRAND',
    CORE_COLOR_CAUTIONARY: 'CORE_COLOR_CAUTIONARY',
    CORE_COLOR_DESTRUCTIVE: 'CORE_COLOR_DESTRUCTIVE',
    CORE_COLOR_ERROR: 'CORE_COLOR_ERROR',
    CORE_COLOR_HEADINGS_TEXT: 'CORE_COLOR_HEADINGS_TEXT',
    CORE_COLOR_INFO: 'CORE_COLOR_INFO',
    CORE_COLOR_PRIMARY: 'CORE_COLOR_PRIMARY',
    CORE_COLOR_TEXT: 'CORE_COLOR_TEXT',
    CORE_COLOR_TEXT_ALT: 'CORE_COLOR_TEXT_ALT',
    CORE_COLOR_TEXT_ON_CANVAS_BRAND: 'CORE_COLOR_TEXT_ON_CANVAS_BRAND',
    CORE_COLOR_TEXT_ERROR: 'CORE_COLOR_TEXT_ERROR',
    CORE_COLOR_UNIVERSAL_ACCESSIBLE_BORDER:
        'CORE_COLOR_UNIVERSAL_ACCESSIBLE_BORDER',
    CORE_COLOR_UNIVERSAL_DECORATIVE_BORDER:
        'CORE_COLOR_UNIVERSAL_DECORATIVE_BORDER',
    CORE_COLOR_UNIVERSAL_FOCUS_HALO: 'CORE_COLOR_UNIVERSAL_FOCUS_HALO',
    CORE_COLOR_UNIVERSAL_HOVER_BG: 'CORE_COLOR_UNIVERSAL_HOVER_BG',
};

export const CORE_TYPOGRAPHY_STYLE_TOKEN_NAMES = {
    // Body Font Family
    CORE_TYPOGRAPHY_FONT_FAMILY: 'CORE_TYPOGRAPHY_FONT_FAMILY',
    // Body Font Family Fallback
    CORE_TYPOGRAPHY_FONT_FAMILY_FALLBACK:
        'CORE_TYPOGRAPHY_FONT_FAMILY_FALLBACK',
    // Body Font Size
    CORE_TYPOGRAPHY_FONT_SIZE: 'CORE_TYPOGRAPHY_FONT_SIZE',
    // Font Size Scale
    CORE_TYPOGRAPHY_FONT_SIZE_SCALE: 'CORE_TYPOGRAPHY_FONT_SIZE_SCALE',
    // Body Font Weight
    CORE_TYPOGRAPHY_FONT_WEIGHT: 'CORE_TYPOGRAPHY_FONT_WEIGHT',
    // Footnotes
    CORE_TYPOGRAPHY_FOOTNOTE_FONT_SIZE: 'CORE_TYPOGRAPHY_FOOTNOTE_FONT_SIZE',
    // Body Font Size (Large)
    CORE_TYPOGRAPHY_LARGE_FONT_SIZE: 'CORE_TYPOGRAPHY_LARGE_FONT_SIZE',
    // Headings Font Family
    CORE_TYPOGRAPHY_HEADINGS_FONT_FAMILY:
        'CORE_TYPOGRAPHY_HEADINGS_FONT_FAMILY',
    // Body Font Family Fallback
    CORE_TYPOGRAPHY_HEADINGS_FONT_FAMILY_FALLBACK:
        'CORE_TYPOGRAPHY_HEADINGS_FONT_FAMILY_FALLBACK',
    // Headings Font Style
    CORE_TYPOGRAPHY_HEADINGS_FONT_STYLE: 'CORE_TYPOGRAPHY_HEADINGS_FONT_STYLE',
    // Headings Font Weight
    CORE_TYPOGRAPHY_HEADINGS_FONT_WEIGHT:
        'CORE_TYPOGRAPHY_HEADINGS_FONT_WEIGHT',
    // H1
    CORE_TYPOGRAPHY_HEADINGS_LEVEL1_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL1_FONT_SIZE',
    // H2
    CORE_TYPOGRAPHY_HEADINGS_LEVEL2_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL2_FONT_SIZE',
    // H3
    CORE_TYPOGRAPHY_HEADINGS_LEVEL3_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL3_FONT_SIZE',
    // H4
    CORE_TYPOGRAPHY_HEADINGS_LEVEL4_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL4_FONT_SIZE',
    // H5
    CORE_TYPOGRAPHY_HEADINGS_LEVEL5_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL5_FONT_SIZE',
    // Headings Line Height
    CORE_TYPOGRAPHY_HEADINGS_LINE_HEIGHT:
        'CORE_TYPOGRAPHY_HEADINGS_LINE_HEIGHT',
    // Body Line Height
    CORE_TYPOGRAPHY_LINE_HEIGHT: 'CORE_TYPOGRAPHY_LINE_HEIGHT',
    // Number Font Weight
    CORE_TYPOGRAPHY_NUMBER_FONT_WEIGHT: 'CORE_TYPOGRAPHY_NUMBER_FONT_WEIGHT',
    // Number (Medium)
    CORE_TYPOGRAPHY_NUMBER_MEDIUM_FONT_SIZE:
        'CORE_TYPOGRAPHY_NUMBER_MEDIUM_FONT_SIZE',
    // Number (Small)
    CORE_TYPOGRAPHY_NUMBER_SMALL_FONT_SIZE:
        'CORE_TYPOGRAPHY_NUMBER_SMALL_FONT_SIZE',
    // Sub-Text
    CORE_TYPOGRAPHY_SUB_TEXT_FONT_SIZE: 'CORE_TYPOGRAPHY_SUB_TEXT_FONT_SIZE',
};

export const CORE_TYPOGRAPHY_MOBILE_STYLE_TOKEN_NAMES = {
    // Footnotes
    CORE_TYPOGRAPHY_FOOTNOTE_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_FOOTNOTE_MOBILE_FONT_SIZE',
    // H1
    CORE_TYPOGRAPHY_HEADINGS_LEVEL1_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL1_MOBILE_FONT_SIZE',
    // H2
    CORE_TYPOGRAPHY_HEADINGS_LEVEL2_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL2_MOBILE_FONT_SIZE',
    // H3
    CORE_TYPOGRAPHY_HEADINGS_LEVEL3_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL3_MOBILE_FONT_SIZE',
    // H4
    CORE_TYPOGRAPHY_HEADINGS_LEVEL4_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL4_MOBILE_FONT_SIZE',
    // H5
    CORE_TYPOGRAPHY_HEADINGS_LEVEL5_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_HEADINGS_LEVEL5_MOBILE_FONT_SIZE',
    // Body Font Size (Large)
    CORE_TYPOGRAPHY_LARGE_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_LARGE_MOBILE_FONT_SIZE',
    // Mobile Font Size Scale
    CORE_TYPOGRAPHY_MOBILE_FONT_SIZE_SCALE:
        'CORE_TYPOGRAPHY_MOBILE_FONT_SIZE_SCALE',
    // Number (Medium)
    CORE_TYPOGRAPHY_NUMBER_MEDIUM_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_NUMBER_MEDIUM_MOBILE_FONT_SIZE',
    // Number (Small)
    CORE_TYPOGRAPHY_NUMBER_SMALL_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_NUMBER_SMALL_MOBILE_FONT_SIZE',
    // Sub-Text
    CORE_TYPOGRAPHY_SUB_TEXT_MOBILE_FONT_SIZE:
        'CORE_TYPOGRAPHY_SUB_TEXT_MOBILE_FONT_SIZE',
};

export const CORE_STATE_STYLE_TOKEN_NAMES = {
    CORE_STATE_DISABLED_OPACITY: 'CORE_STATE_DISABLED_OPACITY',
};

export const CORE_SYSTEM_STYLE_TOKEN_NAMES = {
    CORE_SYSTEM_SCALE: 'CORE_SYSTEM_SCALE',
};

export const CORE_STYLE_TOKEN_NAMES = {
    ...CORE_STATE_STYLE_TOKEN_NAMES,
    ...CORE_SYSTEM_STYLE_TOKEN_NAMES,
    ...CORE_TYPOGRAPHY_STYLE_TOKEN_NAMES,
    ...CORE_TYPOGRAPHY_MOBILE_STYLE_TOKEN_NAMES,
};

export const CORE_TOKEN_NAMES = {
    ...CORE_COLOR_TOKEN_NAMES,
    ...CORE_NEUTRAL_COLOR_TOKEN_NAMES,
    ...CORE_STYLE_TOKEN_NAMES,
};
